<template>
  <div class="history-page">
    <section class="history-hero user-page-banner">
      <div class="history-icon"><CIcon name="cil-history" size="xl" /></div>
      <h2>{{ $t('mainuser.tabHistory') }}</h2>
    </section>
    <CCard class="history-card">
      <CCardHeader class="history-card-header"><h4>{{ $t('userHistory.allTransactions') }}</h4></CCardHeader>
      <UHistoryTable ref="historyTable" history-source="admin" @show-detail="showDetail" />
    </CCard>
    <TicketDetailModal v-if="selectedReport" @close="selectedReport=null"><ReportDetail :report="selectedReport" @close="selectedReport=null" @refresh="refreshHistory" /></TicketDetailModal>
  </div>
</template>

<script>
import UHistoryTable from '@/components/user/Uhistorytable.vue'
import ReportDetail from './ReportDetail.vue'
import TicketDetailModal from '@/components/common/TicketDetailModal.vue'
export default {
  name: 'AdminHistory', components: { UHistoryTable, ReportDetail, TicketDetailModal }, data: () => ({ selectedReport: null }),
  methods: {
    showDetail(item) { this.selectedReport = { ...item }; this.$nextTick(() => document.querySelector('.detail-card')?.scrollIntoView({ behavior: 'smooth', block: 'start' })) },
    refreshHistory() { this.selectedReport = null; this.$refs.historyTable?.loadHistory() },
  },
}
</script>

<style scoped>
.history-page {
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 0 0 30px;
}
.history-hero {
  display: flex;
  align-items: center;
  gap: 18px;
  margin-bottom: 22px;
  padding: 24px;
  border-radius: 12px !important;
  color: #fff;
  background: #1e40af;
  box-shadow: none;
}
.history-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 54px;
  height: 54px;
  flex: 0 0 54px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.14);
}
.history-hero h2,
.history-card-header h4 {
  margin: 0;
  font-weight: 800;
}
.history-hero h2 {
  font-size: 1.6rem;
}
.history-card {
  background: #ffffff !important;
  border: 1px solid rgba(37, 99, 235, 0.10) !important;
  border-radius: 12px !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04) !important;
}
.history-card-header {
  padding: 18px 22px;
  color: #1e40af !important;
  background: #f8fafc !important;
  border-bottom: 1px solid rgba(37, 99, 235, 0.10) !important;
}
@media (max-width: 991.98px) {
  .history-page {
    padding: 0 0 24px;
  }
  .history-hero {
    padding: 18px;
  }
  .history-icon {
    width: 46px;
    height: 46px;
    flex-basis: 46px;
    border-radius: 13px;
  }
  .history-hero h2 {
    font-size: 1.3rem;
  }
  .history-card {
    border-radius: 12px !important;
  }
  .history-card-header {
    padding: 15px 16px;
  }
  .history-card-header h4 {
    font-size: 1.05rem;
  }
}
</style>
